import { Link, useNavigate } from "react-router-dom";
import { Heart, ArrowRight, Trash2, Scale } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { useCompare } from "@/context/CompareContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";

const FavoritesPage = () => {
  const { favorites, clearFavorites } = useFavorites();
  const { addMany } = useCompare();
  const navigate = useNavigate();

  const goCompare = () => {
    addMany(favorites.slice(0, 4));
    navigate("/comparar");
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-12">
        <div className="flex items-center justify-between mb-8">
          <div>
            <span className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400">Tu lista de deseos</span>
            <h1 className="mt-2 font-display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-2">
              <Heart className="h-7 w-7 text-emerald-400" fill="currentColor" /> Favoritos
            </h1>
          </div>
          {favorites.length > 0 && (
            <div className="flex items-center gap-2">
              {favorites.length >= 2 && (
                <Button data-testid="go-compare-btn" onClick={goCompare} className="rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 text-slate-950 font-bold">
                  <Scale className="h-4 w-4 mr-1" /> Comparar
                </Button>
              )}
              <Button data-testid="clear-favorites-btn" variant="outline" onClick={clearFavorites} className="rounded-full">
                <Trash2 className="h-4 w-4 mr-1" /> Vaciar
              </Button>
            </div>
          )}
        </div>

        {favorites.length === 0 ? (
          <div data-testid="favorites-empty" className="text-center py-24 rounded-3xl border border-dashed border-border">
            <Heart className="mx-auto h-12 w-12 text-muted-foreground/40" />
            <p className="mt-4 text-muted-foreground">Aún no has guardado productos.</p>
            <p className="text-sm text-muted-foreground">Toca el corazón en cualquier producto para guardarlo aquí.</p>
            <Link to="/catalogo">
              <Button className="mt-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 text-slate-950 font-bold">
                Explorar catálogo <ArrowRight className="ml-1 h-4 w-4" />
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {favorites.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default FavoritesPage;
